<template>
  <div>
    <div class="max-box">
      <div class="fool-btn flex_c_m">
        <van-button type="default" class="btn-green" :to="{path:'/lineVote',query:{voteId:voteId}}">登录</van-button>
        <!-- <van-button type="default" class="btn-yellow" :to="{path:'/signUp'}">我要报名</van-button> -->
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">
export default {
  data() {
    return {
      voteId:''
    }
  },
  mounted(){
    this.voteId = this.$route.query.voteId;
  },
}
</script>

<style lang="scss" scoped>
.max-box{
  width: 100vw;
  height: 100vh;
  background: url('http://t9.baidu.com/it/u=4169540006,4220376401&fm=79&app=86&size=h300&n=0&g=4n&f=jpeg?sec=1594454093&t=b16d71ea8f2f31a9062215966be76026') no-repeat;
  background-size: 100% 100%;
  .fool-btn{
    position: fixed;
    bottom: 70px;
    width: 100%;
    .btn-green{
      margin-right: 15px;
    }
    .van-button{
      width: 150px;
    }
  }
}
</style>
